<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <h5 v-if="formType == 'edit'" class="form-header">
              Editar {{ equipment }} {{ oldName }}
            </h5>
            <h5 v-else class="form-header">Adicionar {{ equipment }}</h5>
          </div>
          <div class="col-xs-12">
            <b-form-text id="nameInput">Nome *</b-form-text>
            <!-- <b-form-text v-show="form.NAME">Nome *</b-form-text> -->
            <b-form-input
              v-model="form.NAME"
              placeholder="Informe o nome"
              :formatter="notEmpty"
              maxlength="24"
              size="sm"
              aria-describedby="nameInput nameInputLiveFeedback"
              :state="nameState && notRepeatedName"
            />
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>

            <!-- <b-form-text v-show="form.FK_MODEL">Modelo *</b-form-text> -->
            <b-form-text >Modelo *</b-form-text>
            <searchable-select
              v-model="form.FK_MODEL"
              :options="hydroModels"
              text-field="NAME"
              value-field="ID"
              :state="modelState"
              :clearable="false"
              placeholder="Selecione o modelo *"
            />
            <b-form-invalid-feedback
              v-if="!modelState"
              id="modelSelectLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>
          </div>
          <div class="col-xs-12">
            <div class="group-inputs-title">Localização</div>
            <b-form-text >Latitude </b-form-text>
            <!-- <b-form-text v-show="form.LATITUDE">Latitude</b-form-text> -->
            <b-form-input
              v-model="form.LATITUDE"
              placeholder="Latitude"
              aria-describedby="latInputLiveFeedback"
              :state="LATstate"
              :formatter="notEmpty"
              maxlength="40"
              size="sm"
            >
            </b-form-input>
            <b-form-invalid-feedback v-if="!LATstate" id="latInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Latitudes não podem ter valor menor que
              -90 ou maior que 90 graus.
            </b-form-invalid-feedback>
            <b-form-text >Longitude</b-form-text>
            <!-- <b-form-text v-show="form.LONGITUDE">Longitude</b-form-text> -->
            <b-form-input
              v-model="form.LONGITUDE"
              placeholder="Longitude"
              aria-describedby="lonInputLiveFeedback"
              :state="LONstate"
              :formatter="notEmpty"
              maxlength="40"
              size="sm"
            />
            <b-form-invalid-feedback v-if="!LONstate" id="lonInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Longitudes não podem ter valor menor que
              -180 ou maior que 180 graus.
            </b-form-invalid-feedback>


          </div>
          <div class="col-xs-12">
            <div class="group-inputs-title">
              Extra:
            </div>
            <b-form-text>Observações</b-form-text>
            <!-- <b-form-text v-show="form.NOTE">Observações</b-form-text> -->
            <b-form-input
              v-model="form.NOTE"
              placeholder="Observações"
              state="valid"
              maxlength="40"
              size="sm"
            />
            <b-form-checkbox v-model="form.ANA_TELEMETRY" class="mt-2" size="sm">
              Telemetria ANA
            </b-form-checkbox>
          </div>
        </b-form>
      </div>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2">
        <b-btn size="sm" variant="outline-secondary" block @click="$emit('close-form')" class="mr-1 ml-2"> Fechar </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1 mr-2"> Salvar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  checkLAT,
  checkLON,
  testName,
  notEmpty,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";
export default {
  name: "hydro-form",
  components: {
    SearchableSelect,
  },
  props: {
    showForm: Boolean,
    equipment: String,
    oldName: String,
    formType: String,
    alreadyUsedNames: Array,
    hydroModels: Array,
    itemToEdit: [Number, Object],
  },
  data() {
    return {
      errors: [],
      form: {
        NAME: "",
        FK_MODEL: null,
        LATITUDE: null,
        LONGITUDE: null,
        NOTE: null,
        ANA_TELEMETRY: false,
      },
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.form.ID = this.itemToEdit.ID; //IMPORTANTE PARA DIFERENCIAR EDIÇÃO DE ADIÇÃO
          this.form.LAST_NAME = this.itemToEdit.NAME;
          this.form.NAME = this.itemToEdit.NAME;
          this.form.FK_MODEL = this.itemToEdit.FK_MODEL;
          this.form.LATITUDE = this.itemToEdit.LATITUDE;
          this.form.LONGITUDE = this.itemToEdit.LONGITUDE;
          this.form.NOTE = this.itemToEdit.NOTE;
          this.form.ANA_TELEMETRY = !!this.itemToEdit.ANA_TELEMETRY;
        }
      }
    },
  },
  computed: {
    nameState() {
      return testName(this.form.NAME);
    },
    modelState() {
      return !!this.form.FK_MODEL;
    },
    LATstate() {
      let LAT = String(Number(this.form.LATITUDE));
      return checkLAT(LAT);
    },
    LONstate() {
      let LON = String(Number(this.form.LONGITUDE));
      return checkLON(LON);
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
  },
  methods: {
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.form = {
        NAME: "",
        FK_MODEL: null,
        LATITUDE: null,
        LONGITUDE: null,
        NOTE: null,
        ANA_TELEMETRY: false,
      };
    },
    checkForm() {
      this.errors = [];
      let states = [
        this.nameState,
        this.notRepeatedName,
        this.modelState,
        this.LATstate,
        this.LONstate,
      ];
      let erros = [
        "Nome é obrigatório. Permitidos apenas letras, números, pontos, hífens e underlines. Espaços NÃO são permitidos.",
        "Nome escolhido já está em uso. Verifique.",
        "O equipamento precisa ter um modelo.",
        "Latitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Latitudes não podem ter valor menor que -90 ou maior que 90 graus.",
        "Longitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Longitudes não podem ter valor menor que -180 ou maior que 180 graus.",
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      this.form.LATITUDE = !!this.form.LATITUDE
        ? parseFloat(this.form.LATITUDE)
        : null;
      this.form.LONGITUDE = !!this.form.LONGITUDE
        ? parseFloat(this.form.LONGITUDE)
        : null;
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.$emit("submit", this.form);
        this.$emit("close-form");
      }
    },
  },
};
</script>

<style scoped>
#form{
  padding-left: 0;
  padding-right: 0;
}
@media screen and (max-width: 768px) {
  .container-form{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0.5em;
    margin-right: 0;
  }

}
</style>
